export enum SimCardType {
  Voice = 'Voice',
  Data = 'Data',
  Twin = 'Twin',
  Mbb = 'Mbb',
  Unknown = 'Unknown',
}

export enum SimCardDelivery {
  InStore = 'inStore',
  ByMail = 'byMail',
}

export enum SimCardVariant {
  Physical = 'Physical',
  ESim = 'ESim',
  Unknown = 'Unknown',
}

export class SimCard {
  icc: string;
  type: SimCardType;
  isAvailable: boolean;
  customerNumber: string;
  aNumber: string;
}

export interface FaqQuestionResponse {
  name: string;
  htmlAnswer: string;
}

// Order service (AdditionalSimValidator) rejects a B2C order that adds more than one extra SIM
// of a type to the same subscription, even when the subscription has room for more.
export const MAX_NEW_EXTRA_SIMS_PER_TYPE_IN_ORDER = 1;
